module.exports = __webpack_public_path__ + "static/media/btn-more-normal.44b62c68.svg";